import { NgModule } from '@angular/core';

import { CmpsTeamsCallModule } from '../../../teams-call';
import { CmpsCaAnalysisDialogModule } from '../dialog';

@NgModule({
    imports: [CmpsCaAnalysisDialogModule, CmpsTeamsCallModule],
})
export class CmpsCaMeetModule {}
